import moment from 'moment';

/* Date and Time */
export const formatDateTime = (date: string, dateOnly?: boolean, monthToWord?: boolean, withoutYear?: boolean) => {
    if (!date) return '';
    if (date === '-') return date;

    const created = new Date(date);
    const year = created.getFullYear();
    const month = `0${created.getMonth() + 1}`.slice(-2);
    const day = `0${created.getDate()}`.slice(-2);
    const hour = `0${created.getHours()}`.slice(-2);
    const min = `0${created.getMinutes()}`.slice(-2);
    const customMonth = created.toLocaleString('default', { month: 'short' });
    if (!!dateOnly && !!monthToWord && !!withoutYear) return `${day} ${customMonth}`;

    if (!!dateOnly && !!monthToWord) return `${day} ${customMonth} ${year}`;

    if (dateOnly) return `${day}/${month}/${year}`;

    return `${day}/${month}/${year} ${hour}:${min}`;
};

export const formatDateTo_ddMMyyyy = (dateString: string): string => {
    // possible formats from pega
    const formats = ["YYYY-MM-DD", "DD-MM-YYYY", "YYYYMMDD", "YYYYMMDDTHHmmss.SSS [GMT]"];

    let date = moment.utc(dateString, formats, true);

    // If the date is not valid, return the original date string
    if (!date.isValid()) {
        return dateString;
    }

    // Format the date as DD/MM/YYYY
    return date.format('DD/MM/YYYY');
};

export const formatDate = (date: string, dateOnly?: boolean, timeOnly?: boolean) => {
    if (!!date?.includes('T') && dateOnly) {
        const format = new Date(date).toLocaleString();
        return format.split(' ')[0].replace(/,/g, '');
    }
    if (!!date?.includes('T') && timeOnly) {
        const format = new Date(date).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
        return format;
    }
    return date?.replace(/-/g, '-');
};

/**
 * Formats a date value to the required cancellation date format: YYYYMMDDTHHMMSS.sss GMT
 * Example: 20090210T104217.369 GMT
 */
export const formatCancellationDate = (dateValue: any): string => {
    if (!dateValue) return '';
    
    try {
        const date = new Date(dateValue);
        if (isNaN(date.getTime())) return '';
        
        const year = date.getUTCFullYear();
        const month = String(date.getUTCMonth() + 1).padStart(2, '0');
        const day = String(date.getUTCDate()).padStart(2, '0');
        const hours = String(date.getUTCHours()).padStart(2, '0');
        const minutes = String(date.getUTCMinutes()).padStart(2, '0');
        const seconds = String(date.getUTCSeconds()).padStart(2, '0');
        const milliseconds = String(date.getUTCMilliseconds()).padStart(3, '0');
        
        return `${year}${month}${day}T${hours}${minutes}${seconds}.${milliseconds} GMT`;
    } catch (error) {
        console.error('Error formatting cancellation date:', error);
        return '';
    }
};
